import React, { useState } from "react";
import "./HalDitanyakan.css";

const HalDitanyakan = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  return (
    <React.Fragment>
      <div className="container-sering-ditanyakan">
        <div className="parent-model-sering-ditanyakan">
          <img
            src="https://edumatrix-indonesia.com/wp-content/uploads/2025/02/Hal_yang_sering_ditanyakan-1200x1420.webp"
            alt=""
            className="img-model-sering-ditanyakan"
          />
        </div>
        <div className="accordion-item">
          <div className="accordion-header" onClick={() => toggleAccordion(0)}>
            <h3 className="title-faq">Apakah biaya ikut bimbel mahal?</h3>
            <span className="accordion-icon">
              {activeIndex === 0 ? "-" : "+"}
            </span>
          </div>
          <div className={`accordion-body ${activeIndex === 0 ? "open" : ""}`}>
            <p className="jawaban-faq">
              Biaya yang kami tawarkan cenderung terjangkau dengan sistem
              belajar dan materi yang disesuaikan dengan kondisi ter
              update,pastinya dengan tetap mengutamakan kualitas belajar siswa.
            </p>
          </div>
        </div>
        <div className="accordion-item">
          <div className="accordion-header" onClick={() => toggleAccordion(1)}>
            <h3 className="title-faq">
              Bagaimana dengan jadwal belajar kita nanti?
            </h3>
            <span className="accordion-icon">
              {activeIndex === 1 ? "-" : "+"}
            </span>
          </div>
          <div className={`accordion-body ${activeIndex === 1 ? "open" : ""}`}>
            <p className="jawaban-faq">
              Pembelajaran yang terprogram sehingga akan efektif disesuaikan
              dengan paket belajar yang diikuti,fleksibilitas waktu belajar bagi
              kalian yang mengambil program privat sehingga bisa disesuaikan
              dengan kesibukan kalian.
            </p>
          </div>
        </div>
        <div className="accordion-item">
          <div className="accordion-header" onClick={() => toggleAccordion(2)}>
            <h3 className="title-faq">Seberapa penting ikut bimbel?</h3>
            <span className="accordion-icon">
              {activeIndex === 2 ? "-" : "+"}
            </span>
          </div>
          <div className={`accordion-body ${activeIndex === 2 ? "open" : ""}`}>
            <p className="jawaban-faq">
              Dengan ikut bimbel kalian akan memperoleh materi latihan yang
              sesuai dan drilling soal setiap pertemuan jadi kalian akan lebih
              siap mengikuti seleksi, kalian juga akan memperoleh
              informasi,strategi belajar yang efektif,pendampingan yang optimal
              dan selalu diberikan motivasi untuk meningkatkan kepercayaan diri.
            </p>
          </div>
        </div>
        <div className="accordion-item">
          <div className="accordion-header" onClick={() => toggleAccordion(3)}>
            <h3 className="title-faq">Bagaimana jika saya dari luar kota?</h3>
            <span className="accordion-icon">
              {activeIndex === 3 ? "-" : "+"}
            </span>
          </div>
          <div className={`accordion-body ${activeIndex === 3 ? "open" : ""}`}>
            <p className="jawaban-faq">
              Kami tersedia asrama yang nyaman bagi siswa yang dari luar
              kota,lokasi asrama melekat dengan lembaga bimbel kami jadi tidak
              perlu merasa khawatir karena siswa 24 jam terawasi dan terkontrol
              dengan baik.Kami juga memberikan pilihan layanan tempat tinggal
              jika siswa menghendaki tinggal di kost maka kami mencarikan kost
              terdekat dengan biaya mandiri.
            </p>
          </div>
        </div>
        <div className="accordion-item">
          <div className="accordion-header" onClick={() => toggleAccordion(4)}>
            <h3 className="title-faq">
              Adakah jaminan mengikuti bimbel di sini?
            </h3>
            <span className="accordion-icon">
              {activeIndex === 4 ? "-" : "+"}
            </span>
          </div>
          <div className={`accordion-body ${activeIndex === 4 ? "open" : ""}`}>
            <p className="jawaban-faq">
              Kami memberikan pendampingan yang maksimal dan materi prediktif
              yang sudah sesuai dengan materi seleksi dan bagi siswa yang
              mengambil paket program tertentu akan mendapatkan garansi apabila
              gagal seleksi.
            </p>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default HalDitanyakan;
